var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drag-handle",class:{ 
      'disabled': _vm.disabled,
      'horizontal': _vm.direction === 'horizontal',
      'vertical': _vm.direction === 'vertical'
    },on:{"mousedown":_vm.handleMouseDown}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }